import axios from 'axios';

const baseUrlLocal = 'http://localhost:3000/api/';
const baseUrl = 'https://sadima.lnu.se/api/';

/* GET */ 

/**
 * 
 * @returns returns an array with objects of menu subject headers and menu child subjects
 */
export function getMenus() {
    return axios.get(baseUrl + 'GetMenus', { headers: { 'Access-Control-Allow-Origin': '*' } });
}

/**
 * 
 * @param {*} id takes in param of menu item id to query menu children on
 * @returns returns an array of related menu children of an menu item on id
 */
export function getChildren(id) {
    return axios.get(baseUrl + 'getChildren/' + id, { headers: { 'Access-Control-Allow-Origin': '*' } });
}

/**
 * 
 * @returns returns an array of all available languages as objects with id and language-text
 */
export function getAllLanguages() {
    return axios.get(baseUrl + 'GetAllLanguages');
}

/**
 * 
 * @param {*} id 
 * @returns returns dropdown questions or extended child subjects on menu child-id
 */
export function getQuestion(id) {
    return axios.get(baseUrl + 'getQuestion/' + id + '/1');
}

/**
 * 
 * @param {*} languageID takes in param of which language-id to query on
 * @returns returns an array of countries on the language specified by the language-id
 */
export function getAllCountriesOnLanguageID(languageID) {
    return axios.get(baseUrl + 'GetAllCountriesOnLanguageID/' + languageID);
}

/**
 * 
 * @param {*} languageID takes in param of which language-id to query on
 * @returns returns an array of languages on the languages specified by the language-id
 */
export function getAllLanguagesOnLanguageID(languageID) {
    return axios.get(baseUrl + 'GetAllLanguagesOnLanguageID/' + languageID);
}

/**
 * 
 * fetches question details on selected statement id and language from current language selection context
 * @param {*} id 
 * @param {*} languageID takes in param of which language-id to query on
 * @returns return an array information details of a single question
 */
export function getQuestionAndLanguageOnID(id, languageID) {
    return axios.get(baseUrl + 'GetQuestionOnQuestionAndLanguageID/' + id + '/' + languageID, { headers: { 'Access-Control-Allow-Origin': '*' } })
}

/**
 * 
 * @param {*} id 
 * @returns returns string with question type
 */
export function getQuestionTypeOnQuestionID(id) {
    return axios.get(baseUrl + 'getQuestionTypeOnQuestionID/' + id);
}

/**
 * 
 * fetches answer details on selected statement id and language from current language selection context
 * @param {*} id 
 * @param {*} languageID takes in param of which language-id to query on
 * @returns return an array with information on each answer available to the given question
 */
export function getAllAnswersOnQuestionAndLanguageID(id, languageID) {
    return axios.get(baseUrl + 'GetAllAnswersOnQuestionAndLanguageID/' + id + '/' + languageID, { headers: { 'Access-Control-Allow-Origin': '*' } })
}

/**
 * 
 * fetches answer details on selected statement id and language from current language selection context
 * @param {*} id 
 * @param {*} languageID takes in param of which language-id to query on
 * @returns return an array with information on each answer available to the given question
 */
export function getUserCredentials() {
    return axios.get(baseUrl + 'User/api/GetUserCredentials', { headers: { 'Access-Control-Allow-Origin': '*' } })
}


/* CREATE */

/**
 * 
 * creates a new menu item with the provided data and id
 * @param {*} data the data for the new menu item
 * @param {*} id the id for the new menu item
 * @returns {Promise} a promise that resolves to the response of the post request
 */
export function createMenuItem(data, id) {
    return axios.post(baseUrl + 'CreateMenuItem/0/' + id, data, {
        headers: {
            'Content-Type': 'multipart/form-data', // Adjust the content type if necessary
            'Access-Control-Allow-Origin': '*'
        }
    })
}

/**
 * 
 * creates a new question with the provided data, id, and question type
 * @param {*} data the data for the new question
 * @param {*} id the id for the new question
 * @param {*} questionType the type of the question
 * @returns {Promise} a promise that resolves to the response of the post request
 */
export function createQuestion(data, id, questionType) {
    return axios.post(baseUrl + 'CreateQuestion/0/' + id + '/' + questionType, data, {
        headers: {
            'Content-Type': 'multipart/form-data', // Adjust the content type if necessary
            'Access-Control-Allow-Origin': '*'
        }
    })
}

/**
 * 
 * creates a new answer with the provided data and id
 * @param {*} data the data for the new answer
 * @param {*} id the id for the new answer
 * @returns {Promise} a promise that resolves to the response of the post request
 */
export function createAnswer(data, id) {
    return axios.post(baseUrl + 'CreateAnswer/0/' + id, data, {
        headers: {
            'Content-Type': 'multipart/form-data', // Adjust the content type if necessary
            'Access-Control-Allow-Origin': '*'
        }
    })
}


/* DELETE */

/**
 * 
 * deletes a menu item with the specified id
 * @param {*} id the id of the menu item to delete
 * @returns {Promise} a promise that resolves to the response of the delete request
 */
export function deleteMenuItem(id) {
    return axios.delete(baseUrl + 'DeleteMenuItem/' + id, { headers: { 'Access-Control-Allow-Origin': '*' } });
}

/**
 * 
 * deletes a question with the specified id
 * @param {*} id the id of the question to delete
 * @returns {Promise} a promise that resolves to the response of the delete request
 */
export function deleteQuestion(id) {
    return axios.delete(baseUrl + 'DeleteQuestion/' + id, { headers: { 'Access-Control-Allow-Origin': '*' } });
}
